import React, { useState } from "react";
import SignIn from './SignIn/SignIn';
import SignUp from './SignUp/SignUp';

export function Login({ open, setOpen }) {
  const [isSignUpOpen, setSignUpState] = useState(false);
  return (
    <>
      {isSignUpOpen ? 
        <SignUp open={open} setOpen={setOpen} setSignUpState={setSignUpState}/> :
        <SignIn open={open} setOpen={setOpen} setSignUpState={setSignUpState} />
      }
    </>
  );
}
